import React, { Component } from "react";
import {redirectToIESLogin} from  "../service/auth_service_ies.js"

class NewLogin extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: '',
      password: '',
      loggedIn: false,
      isLoading: false,
      error: false,
      errorMessage: '',
      isSsoLogin: false
    }
  }

  render() {
    return (
      <div className=" anonymous  login ">
        <div
          className="container-fluid background-image d-flex justify-content-center align-items-center"
          id="wizme_app"
        >
          { this.state.isSsoLogin
            ? (
              <div className="container" style={{'color': '#113057'}}>
                <div className="row justify-content-center">
                  <div className="col-12 text-center">
                    <div className="spinner-border home-loading" role="status"></div>
                  </div>
                  <div className="col-12 text-center">
                    <div style={{ color: 'rgb(117,117,117)' }}>
                      Estamos fazendo login automático, aguarde...
                    </div>
                  </div>
                </div>
              </div>
            ) : 
            <div className="container">
              <div className="card-login">
                <div>
                  <div>
                    <div>
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        defaultValue="8r2y52LS1OLf3hXonxQ2opIZyS2WziDK"
                      />
                      <div className="bloco-login__logo">
                        <h1 className="card-logo">Wizard</h1>
                      </div>

                      <div className="container_new_login">
                        <p><b>Novidade para voce!</b></p>

                        <p>Agora voce pode utilizar sua <b>senha do Wiz.Me</b> para ter acesso a todas as ferramentas Wizard.</p>

                        <div className="containers-buttons-login">
                            <button className="button-to-ies" onClick={redirectToIESLogin}>Entrar com senha do Wiz.Me</button>
                            <button className="button-to-old-login" onClick={() => window.location.href = '/#/login_catchup'}>Entrar com senha antiga do Catchup</button>
                        </div>

                        <div className="image-login-screen"> </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default NewLogin;
 